import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useMsal }     from '@azure/msal-react';
import { ApiClient }   from '../helpers/apiClient';
import { ProfileDTO }  from '../types/profile';

interface ProfileContextValue {
  profile: ProfileDTO | null;
  loading: boolean;
  refreshProfile: () => Promise<void>;
}

const ProfileContext = createContext<ProfileContextValue>({
  profile: null,
  loading: true,
  refreshProfile: async () => {},
});

export const ProfileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [profile, setProfile]   = useState<ProfileDTO | null>(null);
  const [loading, setLoading]   = useState(true);

  const refreshProfile = useCallback(async () => {
    if (!accounts.length) return;                 
    setLoading(true);
    try {
      const api = ApiClient.getInstance(instance, accounts[0], {
                  baseUrl: process.env.REACT_APP_API_BASE_URL,
      });
      const result = await api?.get<ProfileDTO>('Profile');
      setProfile(result ?? null);
    } finally {
      setLoading(false);
    }
  }, [instance, accounts]);

  useEffect(() => { refreshProfile(); }, [accounts]);

  return (
    <ProfileContext.Provider value={{ profile, loading, refreshProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => useContext(ProfileContext);
